<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6">
        <b-card v-if="registro_no_encontrado">
          <div slot="header">
            <strong>Registro no encontrado</strong>
          </div>
        </b-card>
        <b-card no-body :no-block="true" v-else>
          <div slot="header">
            <strong>{{this.$route.params.id == null ? "Nuevo" :"Actualizar"}} Tipo de Comprobante</strong>
          </div>
          <b-card-body>
            <b-form>
            <b-row>
            <b-col cols="3" col sm="3">
              <b-form-group>
                <label class="col-form-label" for="codigo">Prefijo</label>
                <input
                  type="text"
                  autocomplete="off"
                  id="nombre"
                  v-model.trim="model.prefijo"
                  :class="{'form-control is-invalid': error_prefijo, 'form-control is-valid': !error_prefijo}"
                />
                <b-form-invalid-feedback v-if="error_prefijo">{{ mensaje_prefijo }}</b-form-invalid-feedback>
              </b-form-group>
              </b-col>
              <b-col cols="8" col sm="6">
              <b-form-group>
                <label class="col-form-label" for="nombre">Descripcion</label>
                <input
                  type="text"
                  autocomplete="off"
                  id="nombre"
                  v-model.trim="model.descripcion"
                  :class="{'form-control is-invalid': error_descripcion, 'form-control is-valid': !error_descripcion}"
                />
                <b-form-invalid-feedback v-if="error_descripcion">{{ mensaje_descripcion }}</b-form-invalid-feedback>
              </b-form-group>
              </b-col>
            </b-row>
            </b-form>
          </b-card-body>
          <div slot="footer">
            <button class="btn btn-sm btn-success text-white" @click="guardar()">
              <i class="fa fa-dot-circle-o"></i> Guardar
            </button>
            <router-link class="btn btn-sm btn-danger text-white" :to="'/tipos-comprobantes/'">
              <i class="fa fa-ban" /> Cancelar
            </router-link>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import toastr from "toastr";
export default {
  name: "TipoComprobantesForm",
  data() {
    return {
      areas: [],
      model: {},
      registro_no_encontrado: false,
      nuevo:true,
      error_prefijo:null,
      error_descripcion:null,
      mensaje_prefijo:undefined,
      mensaje_descripcion:undefined
    };
  },
  created() {
    this.cargar();
  },
  methods: {
     procesar_errores(errores) {
      this.error_prefijo = errores.filter(elem => {
        if (elem.field == "prefijo") 
        this.mensaje_prefijo = elem.message;
        return elem;
      });
     this.error_descripcion = errores.filter(elem => {
        if (elem.field == "descripcion") 
        this.mensaje_descripcion = elem.message;
        return elem;
      }); 
    },
    async cargar() {
      if (this.$route.name == "Crear Tipo de Comprobante"){
        this.nuevo = true;
        this.registro_no_encontrado = false;
      }
      else if (this.$route.params.id != null){
        this.nuevo = false;
    try {
          let response = await axios.get("/api/catalogos/tipocomprobantes/"+this.$route.params.id);
          if (response.data == "")
          this.registro_no_encontrado = true;
          else{
            this.registro_no_encontrado = false;
            this.model = response.data;
          } 
        } catch (error) {
          console.log(error);
        }
      }
      else this.registro_no_encontrado = true;
    },
    async guardar() {
  if (this.model.prefijo == undefined || this.model.descripcion ==undefined || this.model.prefijo == "" || this.model.descripcion =="")
        return toastr["warning"]("No dejar campos sin completar");
      try {
        let response = await axios.post("/api/catalogos/tipocomprobantes/store", {
          model: this.model,
          nuevo: this.nuevo
        });
        if (response.data.status == "fail") {
          this.procesar_errores(response.data.errors);
      
        } else this.$router.push("/tipos-comprobantes");
      } catch (error) {
        console.log(error);
      }
    },
  }
};
</script> 